import { Http } from '@/lib/http';

export default class LoanStatisticService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/app/loans/statistics/';
  }

  /**
   * Get count of all the My Workload items for the logged in user
   *
   * returns { Object } a map of all the workload count
   */
  findWorkloadCount() {
    return this.httpClient().get(`${this.endpoint}workload-count`);
  }

  /**
   * Get count of all the progresses on the loan pool tab
   *
   * returns { Object } a map of all the loan pool progress count
   */
  findLoanPoolCount() {
    return this.httpClient().get(`${this.endpoint}loan-pool-count`);
  }

  /**
   * Get count and cash value of all loans with a specific progress
   *
   * @param { string[] } loanProgresses - List of loan progresses
   *
   * returns { Array<Object> } an array of all the loan pool progress count and cash value
   */
  getLoanProgressSummation(loanProgresses = []) {
    return this.httpClient().post(`${this.endpoint}loan-progress-summation`, {
      progresses: loanProgresses
    });
  }

  /**
   * Get Top 10 loan products
   *
   * @param { 'count' | 'cash'  } summationType
   * @param { string[] } loanProgresses - List of loan progresses
   *
   * returns { Object } a map of all the loan pool progress count and cash value
   */
  getTopTenLoanProducts(summationType = 'count', loanProgresses = []) {
    return this.httpClient().post(`${this.endpoint}top-ten-loan-products`, {
      summationType,
      loanProgresses
    });
  }

  /**
   * Get Disbursement summary
   *
   * @param { 'count' | 'cash'  } summationType
   *
   * returns { Object } a map of all the loan pool progress count and cash value
   */
  getDisbursementSummary(filters = {}) {
    return this.httpClient().post(
      `${this.endpoint}disbursement-summary`,
      filters
    );
  }
}
